import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import _ from 'lodash';
import moment from 'moment';
import Spacer from '../spacer';
import BreakdownRow from '../breakdown-row';
import DividerLine from '../divider-line';
import { TYPES, StyledContainer } from './shared';

const isLastDeduction = (array, item) => array.length === array.indexOf(item) + 1;

export default function PaymentTerms(props) {
  const type = TYPES.includes(props.type) ? props.type : PaymentTerms.defaultProps.type;
  return /*#__PURE__*/React.createElement(StyledContainer, null, props.deductions.map((deduction, i) => /*#__PURE__*/React.createElement(View, {
    key: i
  }, /*#__PURE__*/React.createElement(BreakdownRow, {
    type: type === 'default' ? 'emphasis' : 'discounted',
    label: _.upperCase(moment(deduction.date).format('DD MMM YYYY')),
    amount: deduction.amount,
    discountedAmount: deduction.discountedAmount
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Principal",
    amount: deduction.principal
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Fees",
    amount: deduction.fees
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Interest",
    amount: deduction.interest
  }), !isLastDeduction(props.deductions, deduction) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(DividerLine, null), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  })))));
}
PaymentTerms.defaultProps = {
  type: 'default',
  deductions: [{
    amount: 0,
    discountedAmount: 0,
    date: new Date(),
    principal: 0,
    fees: 0,
    interest: 0
  }]
};
PaymentTerms.propTypes = {
  type: PropTypes.oneOf(TYPES),
  deductions: PropTypes.arrayOf(PropTypes.shape({
    amount: PropTypes.number,
    discountedAmount: PropTypes.number,
    date: PropTypes.instanceOf(Date),
    principal: PropTypes.number,
    fees: PropTypes.number,
    interest: PropTypes.number
  }))
};
//# sourceMappingURL=payment-terms.js.map